module.exports = __webpack_public_path__ + "img/marker-oil-transport-empty.a73ed1e9.png";